import React from 'react';
import { FieldType } from '../../../../__generated__/graphql';
import { FieldValue } from '../../../../components/EmployeeData/FieldValue';
import { useNamespacedTranslation } from '../../../../../../hooks/useNamespacedTranslation';
import StringToHtml from '../../../../../../components/StringToHtml';

type FormatFieldValueProps = {
  value: string | null;
  type: FieldType;
  isRichTextArea?: boolean;
};

export const FormatFieldValue: React.FC<FormatFieldValueProps> = ({
  value,
  type,
  isRichTextArea,
}) => {
  const t = useNamespacedTranslation('changeRequests.requestForm');

  if (value === null || value === '') {
    return <>{t('values.empty')}</>;
  }
  if (type === FieldType.Boolean) {
    const isTrue = value.toString() === 'true';
    return <>{isTrue ? t('values.checked') : t('values.unchecked')}</>;
  }
  if (type === FieldType.Textarea && isRichTextArea) {
    return <StringToHtml text={value.toString()} />;
  }
  return <FieldValue value={value.toString()} type={type} options={[]} />;
};
